import React from "react";
import { useSpring, animated } from "react-spring";

const AnimatedNavItem = ({ href, onClick, children }) => {
  const { color, transform } = useSpring({
    from: { color: "#ffffff", transform: "scale(1)" },
    to: async (next) => {
      await next({ color: "#00ff00", transform: "scale(1.1)" });
      await next({ color: "#ffffff", transform: "scale(1)" });
    },
  });

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <animated.li style={{ color, transform }}>
      <a href={href} className="page-scroll" onClick={handleClick}>
        {children}
      </a>
    </animated.li>
  );
};

export const Navigation = (props) => {
  const handleWeeklyUpdatesClick = () => {
    // Call the function inside features.jsx here
    // For example, you can pass a prop to Navigation component and call it like props.onWeeklyUpdatesClick()
    // Or you can use a state management library like Redux to dispatch an action
    console.log("Weekly Updates clicked!");
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            ParrotDesign
          </a>
        </div>

        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            <AnimatedNavItem href="#weekly_updates" onClick={handleWeeklyUpdatesClick}>
              Weekly Updates
            </AnimatedNavItem>
            <AnimatedNavItem href="#about">About</AnimatedNavItem>
            <AnimatedNavItem href="#services">Services</AnimatedNavItem>
            <AnimatedNavItem href="#Youtube_thumbnails">Youtube Thumbnails</AnimatedNavItem>
            <AnimatedNavItem href="#testimonials">Testimonials</AnimatedNavItem>
            <AnimatedNavItem href="#team">Team</AnimatedNavItem>
            {/* <AnimatedNavItem href="#contact">Contact</AnimatedNavItem> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};
